// Unpublished Work © 2021-2025 Deere & Company.

import {
    RESET_CUSTOMER_PROFILE,
    SET_CUSTOMER_PROFILE_PAGE_STATUS
} from '../../action-list';
import {PageStatus} from '../../state/struct/page-status';

const setCustomerProfilePageStatus = (state, action) => action.pageStatus;

const resetProfileStatus = () => PageStatus.meta.map.COMPLETE;

export function status(state = PageStatus.meta.map.COMPLETE, action = {}) {
    const actionHandlers = {
        [SET_CUSTOMER_PROFILE_PAGE_STATUS]: setCustomerProfilePageStatus,
        [RESET_CUSTOMER_PROFILE]: resetProfileStatus
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
